import IconCell from './IconCell';
import RichTextCell from './RichTextCell';
import { RowFields } from './tableSpotTypes';

type RowProps = {
  row: RowFields;
  isRowOdd: boolean;
  colors: {
    backgroundOddCells: string;
    backgroundEvenCells: string;
  }[];
};

const Row = ({ row: { cells }, isRowOdd, colors }: RowProps) => {
  return (
    <tr className="h-full">
      {cells.map((cell, index) => {
        const background =
          (isRowOdd
            ? colors?.at(index)?.backgroundOddCells
            : colors?.at(index)?.backgroundEvenCells) || 'white';
        if ('icon' in cell) {
          return <IconCell key={cell.id} cell={cell} background={background} />;
        }

        return (
          <RichTextCell
            key={cell.id}
            cell={cell}
            background={background}
            colspan={cell.colspan?.value}
          />
        );
      })}
    </tr>
  );
};

export default Row;
